// extracted by mini-css-extract-plugin
export default {"filter-cell":"table-filter-cell_filter-cell__bPURX","filter-align-start":"table-filter-cell_filter-align-start__p9Z-E"};